"use strict";
exports.__esModule = true;
var gremlinsHorde_1 = require("./gremlinsHorde");
exports.GremlinsHorde = gremlinsHorde_1.GremlinsHorde;
exports.gremlins = gremlinsHorde_1.gremlins;
exports["default"] = gremlinsHorde_1.gremlins;
